import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../components/layout/SiteShell";
import ContentPageLayout from "../components/content/ContentPageLayout";
import SEO from "../components/seo/SEO";

export default function TermsPage() {
  return (
    <SiteShell>
      <SEO
        title="Terms of Service | MossMatrix"
        description="MossMatrix terms of service: orders, shipping, refunds, and product use. Launch draft for legal review."
        path="/terms"
      />
      <ContentPageLayout
        eyebrow="Legal"
        title="Terms of Service"
        subtitle="Launch placeholder terms. Replace with counsel-approved language covering your country, fulfilment partners, and return windows."
      >
        <div className="max-w-3xl text-sm text-botanical/85 space-y-4 leading-relaxed">
          <p>
            By placing an order you confirm you’re of legal age in your region and that information submitted at checkout is accurate. MossMatrix gel is a food-style product. Follow storage guidance and consult professionals for health questions.
          </p>
          <p>
            Shipping timelines, carrier choices, and refund policies will be finalised in your merchant agreement. Link those policies here when ready.
          </p>
          <p>
            MossMatrix is not liable for misuse, allergic reactions, or outcomes from ignoring storage instructions. If a jar arrives damaged, contact us within 48 hours with photos so we can make it right.
          </p>
        </div>
        <p className="mt-10 text-sm">
          <Link to="/privacy-policy" className="underline hover:text-forest">
            Privacy policy
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
